import './assets/i18n';
import './index.css';

import * as Sentry from '@sentry/browser';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './app/App';
import * as serviceWorker from './serviceWorker';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://475cec437f1a4c278d0759dd110690d3@o368956.ingest.sentry.io/5205643',
    release: `${process.env.REACT_APP_NAME}@${process.env.REACT_APP_VERSION}`,
  });
}

const render = () => {
  const app = (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  ReactDOM.render(app, document.getElementById('root'));
};

render();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
